import { EmployeeAuthorizationModel } from "./EmployeeAuthorizationModel";

export class AccountModel {  
  authorizationRoles: EmployeeAuthorizationModel[]=[];
  createdBy: string;
  createdDate: Date;
  departmentId: string;
  eisNumber: string;
  email: string;
  employeeNumber: string;
  employmentTerminationDate: Date;
  enrollmentDate: Date;
  firstName: string;
  fullName: string;
  id: string;
  inactive: boolean;
  initials: string;
  isExpert: boolean;
  jobId: string;
  lastModifiedBy: string;
  lastModifiedDate: Date;
  lastName: string;
  managerId: string;
  mobileNumber: string;
  phoneNumber: string;
  prefixLastName: string;
  regionId: string;
  timeStamp: string;
  }